// @ts-strict

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { isEmpty } from 'lodash';

export interface SelectContainerChosenValue<T extends Record<string, any> = Record<string, any>> {
  choosenValue: T;
  title: string;
}

@Component({
  selector: 'app-select-container',
  templateUrl: './select-container.component.html',
  styleUrls: ['./select-container.component.scss']
})
export class SelectContainerComponent implements OnInit, OnChanges {
  @Input() data: Record<string, any>[] = [];
  @Input() title?: string;
  @Input() id?: string;
  @Input() type?: string;
  @Input() submitted: boolean = false;
  @Input() tooltipText?: string;
  @Input() borderWidth?: number;
  @Input() borderRadius?: number;
  @Input() shouldTranslate?: boolean;
  @Input() idOfDefaultValue?: number;
  @Input() idOfDefaultValueCanBeZero? = false;
  @Input() fontSize?: number;
  @Input() placeholder = '';
  @Output() emitValue = new EventEmitter<SelectContainerChosenValue<Record<string, any>[number]>>();
  dropdownActive = false;
  choosenValue: Record<string, any>[number] | undefined;
  validationError = false;
  constructor() {}

  get isInvalid(): boolean {
    return this.submitted && isEmpty(this.choosenValue);
  }
  get isValid(): boolean {
    return this.submitted && !this.isInvalid;
  }
  get isButtonSelect(): boolean {
    return this.type === 'buttonSelect';
  }

  get isEmpty(): boolean {
    return isEmpty(this.choosenValue);
  }

  ngOnInit(): void {
    if (this.idOfDefaultValue || this.idOfDefaultValueCanBeZero) {
      this.choosenValue = this.data[this.idOfDefaultValue || 0];
    } else {
      this.choosenValue = this.data[0];
      if (this.placeholder) {
        this.choosenValue = {};
      }
    }
  }

  ngOnChanges(): void {
    if (this.idOfDefaultValue) {
      this.choosenValue = this.data[this.idOfDefaultValue];
    }
  }

  /**
   * Function to show/hide dropdown menu
   */
  dropdownMenu(): void {
    this.dropdownActive = !this.dropdownActive;
  }

  /**
   * Function to choose value
   * @param element information from clicked position
   */
  getValue(element: Record<string, any>[number]) {
    this.choosenValue = element;
    this.emitValue.emit({ choosenValue: element, title: this.title || '' });
  }

  close(): void {
    this.dropdownActive = false;
  }
}
